import { getMediaRoomsAPI, deleteMediaRoomAPI, renameMediaRoomAPI, generateShareableLinkAPI } from 'api/mediaRooms';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styles from './MediaRoomsList.module.scss';
import { errorToast, successToast } from 'toasts/Toasts';
import { VscClose } from 'react-icons/vsc';
import { IoCheckmarkOutline } from 'react-icons/io5';
import { SlSettings } from 'react-icons/sl';
import CheckAuthLoadingPage from 'components/pages/CheckAuthLoadingPage/CheckAuthLoadingPage';
export default function MediaRoomsList () {
  const [mediaRooms, setMediaRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [rename, setRename] = useState('');
  const [renameId, setRenameId] = useState(null);
  const [settings, setSettings] = useState(null);
  const [shareModal, setShareModal] = useState(false);
  const [shareLink, setShareLink] = useState('');
  const [, setSelectedRoomId] = useState(null);

  const navigate = useNavigate();
  const templatesData = useSelector((state) => state.templates.templates);

  useEffect(() => {
    fetchMediaRooms();
  }, []);

  async function fetchMediaRooms () {
    try {
      const data = await getMediaRoomsAPI();
      setMediaRooms(data?.data || []);
    } catch (err) {
      setError('Failed to load media rooms.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this media room?')) return;

    try {
      await deleteMediaRoomAPI(id);
      setMediaRooms((prevRooms) => prevRooms.filter((room) => room._id !== id));
      successToast('Media room deleted successfully.');
    } catch (err) {
      errorToast('Failed to delete media room.');
    }
  };

  const handleRename = async (id) => {
    if (!rename.trim()) {
      errorToast('Name cannot be empty!');
      return;
    }

    try {
      await renameMediaRoomAPI(id, rename);
      successToast('Media room renamed successfully!');
      setRename('');
      setRenameId(null);
      fetchMediaRooms();
    } catch (error) {
      errorToast('Failed to rename media room.');
    }
  };

  if (loading) return <CheckAuthLoadingPage />;
  if (error) return <p className='error'>{error}</p>;

  const handleGenerateShareLink = async (id) => {
    try {
      const link = await generateShareableLinkAPI(id);
      if (link) {
        setShareLink(link);
        setSelectedRoomId(id);
        setShareModal(true);
        successToast('Shareable link generated successfully!');
      } else {
        errorToast('Failed to generate shareable link.');
      }
    } catch (error) {
      errorToast('Error generating shareable link.');
    }
  };
  return (
    <div className={styles.container}>
      {
        mediaRooms?.length > 0 &&
        <h1>All Media Rooms</h1>
      }
      <div className={styles.templates}>
        {mediaRooms?.length > 0 
        ? mediaRooms.map((room) => {
              const matchingTemplate = templatesData.find((template) => template.id === room.templateId);
              return (
                <div key={room._id} className={styles.templateContainer}>
                  <div onClick={() => navigate(`/mpublisher/media-room/${room._id}`)} className={styles.template}>
                    <div
                      onClick={(e) => {
                        e.stopPropagation()
                        setSettings(room._id)
                      }}
                      className={styles.settings}>
                      <SlSettings />
                    </div>
                    <img src={matchingTemplate?.thumbnail || '/default-thumbnail.jpg'} alt={room.name} />
                    {
                      settings === room._id &&
                      <div
                        onMouseLeave={() => setSettings(false)}
                        className={styles.btns}>
                        <button onClick={(e) => { e.stopPropagation(); handleDelete(room._id); }
                        }>Delete</button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setRename(room.name); setRenameId(room._id);
                          }
                          }
                        >Rename</button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setShareModal(true);
                            handleGenerateShareLink(room._id);
                          }
                          }
                        >Share</button>
                      </div>
                    }
                  </div>

                  {renameId === room._id 
                  ? (
                    <div className={styles.renameMode}>
                      <input
                        type='text'
                        value={rename}
                        onChange={(e) => setRename(e.target.value)}
                      />
                      <div className={styles.checks}>
                        <button onClick={() => { setRename(''); setRenameId(null); }}> <VscClose />
                        </button>
                        <button onClick={() => handleRename(renameId)}>
                          <IoCheckmarkOutline />
                        </button>
                      </div>

                    </div>
                  ) 
                  : (
                    <p>{room.name}</p>
                  )}
                </div>
              );
            })
            : <div className={styles.noitems}>
              <p>No Media Rooms Found</p>
              <button
                onClick={() => navigate('/mpublisher/media-rooms-templates')}
              >
                Create New Media Room
              </button>
            </div>
        }
      </div>
      {shareModal &&
         <div className={styles.modal}>
          <div className={styles.frame}>
            <p>Share this link:</p>
            <input type='text' value={shareLink} readOnly />
            <button onClick={() => navigator.clipboard.writeText(shareLink)}>Copy</button>
            <button onClick={() => setShareModal(false)}>Close</button>
          </div>
        </div>
      }
    </div>
  );
}
